import { Box, useMediaQuery, useTheme } from '@mui/material';
import HeroSection from '../components/HeroSection/HeroSection';
import HowWorksList from '../components/HowItWorksItem/HowWorksList';
import { OrganizationsAndEmployeesList } from '../components/OrganizationsAndEmployeesList/OrganizationsAndEmployeesList';
import { WhatWeWillDo } from '../components/WhatWeWillDo/WhatWeWillDo';
import {
  organizationContent,
  organizationList,
  DESCRIPTION_ORGANIZATION,
} from '../constants';

export const ForOrganizations: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
      <HeroSection description={DESCRIPTION_ORGANIZATION} isMobile={isMobile}>
        <HowWorksList list={organizationList} />
      </HeroSection>
      <Box
        sx={{
          backgroundColor: '#91C7CB',
          textAlign: 'center',
          color: '#fff',
          fontSize: '23px',
          py: '50px',
        }}
      >
        When difficult life situations like addiction, cancer, or depression
        <br />
        create stress about the health and wellbeing of your employees
        <br /> or their loved ones, OneVillage is here to help
      </Box>
      <OrganizationsAndEmployeesList
        isMobile={isMobile}
        lists={organizationContent}
      />
      <WhatWeWillDo isMobile={isMobile} />
    </>
  );
};
